import { Skeleton } from '@material-ui/lab';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  border-radius: 0px 0px 0px 16px;

  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  height: 100%;
`;

export const ContainerDocuments = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  min-height: 0;
  scrollbar-width: thin;
  scrollbar-color: #e0e0e0 transparent;
  overflow-x: hidden;
`;

export const DocumentWrapper = styled.div`
  margin-bottom: 16px;
  width: 70%;
  min-height: 15vh;
  height: 25vh;
  max-height: 25vh;
  border: 1px solid #e0e0e0;
  overflow: hidden;
  &[data-actived-border='true'] {
    border-color: #00b0aa;
  }

  &[data-is-first='true'] {
    margin-top: 16px;
  }

  :hover {
    cursor: pointer;
  }

  :active {
    border-color: #00b0aa;
  }
`;

export const ButtonWrapper = styled.div`
  position: absolute;
  bottom: 8px;
  left: 16px;
  right: 16px;
  width: auto;

  & > button {
    width: 100%;
  }
`;

export const ContainerCheckboxAndDocument = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
`;

export const TypographyCustom = styled.div`
  font-weight: 600;
  font-size: 14px;
  margin-top: 8px;
`;

export const SkeletonCustom = styled(Skeleton)`
  &.MuiSkeleton-root {
    width: 70%;
    height: 250px;
  }
`;

export const IframeViwerPdf = styled.iframe`
  pointer-events: none;
  width: 100%;
  height: 110%;
  margin: 0px;
  padding: 0px;
  overflow: hidden;
`;
